import { CaseServiceFilterOptions } from '../../enums/filters-and-searchs/caseservice.filter.options';


export const CaseServiceFilterOptionsDetail = new Map<number, string>([
    [CaseServiceFilterOptions.None, 'None'],
    [CaseServiceFilterOptions.DeletedCaseServices, 'Deleted Case Services'],
]);
